export default "__VITE_ASSET__DYvQcifW__"